@let current = selected();

<button
  type="button"
  (click)="dropdown.toggle()"
  aria-haspopup="listbox"
  [attr.aria-expanded]="dropdown.isOpen()"
  [attr.aria-label]="'Size: ' + current.label"
  class="flex items-center gap-2 rounded-lg bg-white py-1.5 pl-2 pr-3 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-gray-200 hover:bg-gray-50 transition-colors"
>
  <app-size-glyph size="sm" [dimensions]="current.size" [active]="!!current.size" />
  <span class="whitespace-nowrap">{{ current.label }}</span>
  <app-icon name="chevron" class="w-4 h-4 text-gray-400 transition-transform" [class.rotate-180]="dropdown.isOpen()" />
</button>

@if (dropdown.isOpen()) {
  <div class="absolute left-0 z-30 mt-2 w-64 rounded-2xl bg-white p-1.5 shadow-xl ring-1 ring-gray-200">
    <ul
      cdkListbox
      [cdkListboxValue]="[value()]"
      (cdkListboxValueChange)="dropdown.choose($event, value)"
      aria-label="Sizes"
      class="max-h-80 overflow-y-auto focus:outline-none"
    >
      @for (option of options(); track option.key) {
        @let active = option.key === current.key;
        <li
          [cdkOption]="option.key"
          [cdkOptionTypeaheadLabel]="option.label"
          class="flex cursor-pointer items-center gap-3 rounded-xl px-2.5 py-2 transition-colors hover:bg-gray-50 aria-selected:bg-blue-50/60 [&.cdk-option-active]:bg-gray-100"
        >
          <app-size-glyph [dimensions]="option.size" [active]="active" />
          <span class="min-w-0 flex-1">
            <span class="flex items-center gap-1.5">
              <span class="truncate text-sm" [class]="active ? 'font-semibold text-gray-900' : 'font-medium text-gray-800'">
                {{ option.label }}
              </span>
              @if (option.mostPopular) {
                <span class="shrink-0 rounded-full bg-amber-100 px-1.5 py-px text-[10px] font-semibold uppercase tracking-wide text-amber-700">
                  Most popular
                </span>
              }
            </span>
            @if (option.price) {
              <span class="block text-xs text-gray-400">{{ option.price }} per print</span>
            }
          </span>
          @if (active) {
            <app-icon name="check" class="w-4 h-4 text-[#0A84FF]" />
          }
        </li>

        <!-- Divider between "All sizes" and the individual sizes -->
        @if ($first && !$last) {
          <li role="separator" class="my-1 h-px bg-gray-100"></li>
        }
      }
    </ul>
  </div>
}
